// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__37Tw1","bigColWidth":"Table_bigColWidth__2DWzB","biggerColWidth":"Table_biggerColWidth__2wcRk","row":"Table_row__2013X","col":"Table_col__1kdbh"};